import React from "react";
import { Grid, Typography } from "@mui/material";
import { memo, useEffect } from "react";
import { useResetRecoilState } from "recoil";
import LoginField from "src/Patient/components/LoginField";
import PasswordLoginField from "src/Patient/components/PasswordLoginField";
import {
  errorsReservationUserState,
  valuesFormReservationUserState,
} from "src/Patient/state/atoms";
import AutocompleteProfessionals from "./components/AutocompleteProfessionals";
import AutocompleteSpecialities from "./components/AutocompleteSpecialities";
import InputFechaIni from "./components/InputFechaIni";
import InputFechaFin from "./components/InputFechaFin";
import { InfoOutlined } from "@mui/icons-material";

const FormLogin = memo(({ xs = 12, sm = 12, onKeyEnter }) => {
  const resetErrorsFormLogin = useResetRecoilState(errorsReservationUserState);
  const resetFormLogin = useResetRecoilState(valuesFormReservationUserState);

  useEffect(() => {
    return () => {
      resetErrorsFormLogin();
      resetFormLogin();
    };
  }, []);

  return (
    <Grid className="animate__animated animate__fadeIn" container spacing={2}>
      <Grid item xs={xs} sm={sm}>
        <AutocompleteSpecialities size={"small"} styles={{}} />
      </Grid>
      <Grid item xs={xs} sm={sm}>
        <AutocompleteProfessionals size={"small"} styles={{}} />
      </Grid>
      <Grid item xs={xs} sm={sm}>
        <InputFechaIni />
      </Grid>
      <Grid item xs={xs} sm={sm}>
        <InputFechaFin />
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          gutterBottom
        >
          <InfoOutlined /> El inicio y fin de vigencia es el periodo en que se
          desea realizar la reserva.
        </Typography>
      </Grid>
      <Grid item xs={xs} sm={sm}>
        <LoginField />
      </Grid>

      <Grid item xs={xs} sm={sm}>
        <PasswordLoginField onKeyEnter={onKeyEnter} />
      </Grid>
    </Grid>
  );
});

export default FormLogin;
